import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IInApp } from '~/types/iap'

import InAppResume from '~/components/InAppResume'

const InAppResumeCellRenderer = ({ data }: ICellRendererParams<IInApp>): ReactElement => {
  if (!data) return <div />

  return (
    <div className="in-app-resume-cell-renderer-component">
      <InAppResume inApp={data} />
    </div>
  )
}

export default InAppResumeCellRenderer
